var project = require('../../settings');
var utils = require('./modules/utils');

/* Event Handlers  */
(function ($, $PB) {
    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.equal');


        utils.equalHeight('.specialty','.profiles-row');
        utils.equalHeight('.specialty','.builder-table');


        $(window).trigger('resize').trigger('scroll');

        setInterval(function() {
            $(window).trigger('resize').trigger('scroll');
            $grid.isotope();
        }, 1000);

        $('.profiles-row').css('visibility','visible');
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "navbars": [
                {
                    "position": "bottom",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            "searchfield": {
                "search": false,
            },
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }, {
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's',
                    "id": 'mobile-search'
                }
            }
        }
    );

    /*$("#menu-wrapper").mmenu({
        "navbar": {
            "title": mmtitle,
        },
        "extensions": [
            "pagedim-black",
            "theme-dark",
            "position-right"
        ],
        classNames: {
            fixedElements: {
                fixed: "fix",
                sticky: "stick"
            }
        }
    });*/

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.tabs-container ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.tabs-container ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tabs-container ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#"+$tab_id).addClass('open');

    });

    $(document).on('click', '.single-accordion .accordion-header', function() {
        var $column = $(this).parent();
        $column.toggleClass('open');
        $column.find('.accordion-inner').slideToggle({
            duration: 250,
            progress: function() {
                $(window).trigger('resize');
            }
        });
    });

    // quick search regex
    var qsRegex;
    var filterBy = '';

    // init Isotope
    var $grid = $('.profiles-row').isotope({
        itemSelector: '.single-profile',
        layoutMode: 'fitRows',
        filter: function() {
            console.log(filterBy, qsRegex);
            if (filterBy != '') {
                if ($(this).is(filterBy)) {
                    return qsRegex ? $(this).attr('data-title').match( qsRegex ) : true;
                }
            } else {
                return qsRegex ? $(this).attr('data-title').match( qsRegex ) : true;
            }
        }
    });

    // bind filter on select change
    $('.filter-select').on( 'change', function() {
        // get filter value from option value
        filterBy = this.value;
        console.log('What is this: ' + filterBy);
        $grid.isotope();
    });

    // use value of search field to filter
    var $quicksearch = $('.quicksearch').keyup( debounce( function() {
        qsRegex = new RegExp( $quicksearch.val(), 'gi' );
        $grid.isotope();
    }, 200 ) );

    setTimeout(function () {
        $grid.isotope();
    }, 1000);

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout( timeout );
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply( _this, args );
            }
            timeout = setTimeout( delayed, threshold );
        };
    }

    $('.search-bar .search-button').on('click', function(){
        $(this).parent().toggleClass('open');
    });

    // $(window).on('resize', function() {
    //     $('.builder-section:first, .blog-banner, .template-archive').css('padding-top',
    //         $('.main-header').outerHeight() + Number($('.builder-section:first, .blog-banner, .template-archive').css('padding-bottom').replace('px', ''))
    //     );
    // });

    $(window).on('load resize', function() {
        $('.site-wrapper').css('padding-top',
            $('.main-header').outerHeight()
        );
    });

})(jQuery, KMDGPB.jQuery);